// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useEffect, useMemo,
    useState} from 'react';
import cn from 'classnames';
import {t_countries} from '../../lib/use_dashboard_data';
import {Group_table, Plan_table} from './plan_table';
import {Proxy_type, t_order} from '../../../../hola/pub/ui/pro/cp/orders';
import {get_list_of_products} from '../../../../hola/pub/ui/pro/products';
import {Configured_proxy_list} from '../toolip/configured_proxy_list';
import {Configure_all} from '../toolip/configure_proxies';
import {Empty_plans} from './empty_plans';
import {useHistory} from 'react-router-dom';
import {align_table_sizes, combine_and_sort_zones,
    get_free_zone, get_price_per_gb, get_visible_actions,
    is_unlimited_proxy_type,
    new_order_ids, ORDER_TYPE_NAMES, total_orders_count} from './utils';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {Button} from '../../../../hola/pub/lib/button';
import {use_intercom} from '../../../../hola/pub/ui/intercom';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import Icon_plus from '../../img/icons/16/plus.svg';
import Icon_add_to from '../../img/icons/24/add_to.svg';
import Icon_chevron_down from '../../../../hola/pub/img/hola2023/icons/16/chevron_down.svg';
import Icon_support from '../../img/icons/16/support.svg';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Btn_loader} from './btn_loader';
import {IP_whitelist} from './ip_whitelist';
import {use_app_context} from '../../lib/app_context';
import {Action_menu} from './action_menu/action_menu';
import {Support_form} from './support_form';
import {Bandwidth_info, Bandwidth_low_popup} from './bandwidth_info';
import {Notification_modals} from './notification_modals';
import {get_payment_extra_url} from './utils/checkout';

import styles from '../../pages/toolip.io/dashboard.module.less';

interface i_my_plans_props {
    countries?: t_countries;
    need_login: ()=>void;
}

export const type_to_table_cn: Record<Proxy_type, string> = {
  [Proxy_type.SDC]: styles.table_shared_dc,
  [Proxy_type.DDC]: styles.table_dedicated_dc,
  [Proxy_type.ISP]: styles.table_isp,
  [Proxy_type.ISPPREM]: styles.table_isp_plus,
  [Proxy_type.RES]: styles.table_smart_resi,
  [Proxy_type.EV_RES]: styles.table_smart_resi,
  [Proxy_type.SNK]: styles.table_smart_resi,
  [Proxy_type.SHARED_ISP]: styles.table_dedicated_dc,
  [Proxy_type.EV_ISP]: styles.table_dedicated_dc,
  [Proxy_type.SCR]: styles.table_dedicated_dc,
  [Proxy_type.UNKNOWN]: styles.table_dedicated_dc,
};

export const Active_plans = (props: i_my_plans_props)=>{
    const {theme} = useContext(Settings_context);
    const {dashboard, user} = use_app_context();
    const {dispatch, info} = dashboard;
    const history = useHistory();
    const {params, set} = use_pathname();
    const {set_qs} = use_qs_with_set();
    const list_of_products = useMemo(()=>get_list_of_products('toolip'), []);
    const orders_count = useMemo(()=>total_orders_count(info?.orders),
        [info?.orders]);
    const [addon_modal_order, set_addon_modal_order] =
        useState<t_order | null>(null);
    const extra_checkout = (zone_id: string, extra_limit: number,
        price: number, group_id?: string)=>
        {
        const redirect = get_payment_extra_url({zone_id, group_id, extra_limit,
            price});
        history.push(redirect);
    };
    useEffect(()=>{
        const ids = new_order_ids(info?.orders);
        if (ids.length>0)
            dispatch({type: 'mark_orders_as_seen', payload: {order_ids: ids}});
    }, [info?.orders]);
    const free_zone_fake = get_free_zone(info.free_zone_params);
    useEffect(()=>{
        if (!info.orders)
            return;
        const tables = document.querySelectorAll<HTMLTableElement>(
            `.${styles.plan_table}`);
        const align_plan_tables = ()=>{ align_table_sizes(tables); };
        align_plan_tables();
        window.addEventListener('resize', align_plan_tables);
        return ()=>{
            window.removeEventListener('resize', align_plan_tables);
        };
    }, [info?.orders]);
    const intercom = use_intercom();
    const {width} = use_screen();
    const is_mobile = width < 768;
    const [active, set_active] = useState<t_order>();
    const toggle_active = id=>{
        set_active(v=>{
            if (v==id)
                return undefined;
            return id;
        });
    };
    const visible_actions = get_visible_actions(active);
    const show_config_list = ()=>{
        if (!active)
            return;
        set({configure_proxy: active._id, type: active.type});
    };
    const generate_proxies = ()=>{
        if (!active)
            return;
        set({configure_proxies: active._id, type: active.type});
        if (active.type=='smart_resi')
            set_qs({example: '1'});
    };
    useEffect(()=>{
        if (!is_mobile)
            return;
        intercom[active ? 'hide' : 'show']();
    }, [active]);
    const free_plan_maxed = active?.free_zone &&
        active?.usage_info?.used >= active?.plan_limit;
    if (!info.inited)
        return null;
    const combined = combine_and_sort_zones(info.orders, info.zone_groups);
    if (combined.length > 0)
    {
      return <Fragment>
        <Configured_proxy_list
          active={!!(params.configure_proxy && params.type)}
          orders={info.orders}
          zone_groups={info.zone_groups}
          get_product_name={type=>
            list_of_products.find(item=>item.value==type)?.title}
          ui_config={{
            show_rotate: true,
            show_rotate_error_icon: false,
            download_list_icon: <Icon_chevron_down/>,
            btn_loader: <Btn_loader/>,
            flag_round: true,
            render_ip_whitelist: (_id: string, type: string)=>
              _id && type ?
                <IP_whitelist zone_id={_id} /> : null,
            render_new_conf_button: (on_click: ()=>void)=>{
              return <div className={styles.add_new_config}>
                <Button color='transparent' on_click={on_click}
                  size={'sm'} round={false}
                  caption={<>
                    <Icon_plus />
                    Create another configuration
                  </>}/>
                </div>;
            },
          }}
        />
        <Configure_all
          ui_config={{
            label_country: 'Choose country',
            labels_always_visible: true,
            show_virtual_conf_for_gb: true,
            socks5_opts: {
              label: 'Choose protocol',
              next_line: true,
            }
          }}
          orders={info.orders}
          zone_groups={info.zone_groups}
          countries={props.countries}
        />
        <Fragment>
          <Notification_modals/>
          {combined.map(c=>{
            if ('start' in c)
            {
              return <div className={cn(styles.table_container,
                styles.plans_content, styles.mb40)} key={c._id}>
                <Group_table
                  group={c}
                  title='Event & E-commerce Residential proxies'
                  wrapper_cn={styles.table_group}
                />
              </div>;
            }
            const p_item = list_of_products.find(item=>item.value == c.type);
            return <div className={cn(styles.table_container,
              styles.plans_content, styles.mb40)}
              key={c.type}>
                <Plan_table type={c.type} items={c.orders}
                  show_recently_expired
                  orders_count={orders_count}
                  countries={props.countries} hide_actions={is_mobile}
                  title={p_item?.title} with_onboarding
                  active={active} toggle_active={toggle_active}
                  wrapper_cn={type_to_table_cn[c.type]}
                  render_bandwidth_info={(o, u?, is_extra?)=>
                  <Bandwidth_info order={o}
                    only_free_zone_visible={orders_count==1}
                    is_extra_row={is_extra}
                    usage={u}
                    on_checkout={extra_checkout}
                  />}
                  show_order_token
                  render_plan_popup_actions={item=>{
                    return <Plan_actions
                      item={item}
                      is_hidden={is_mobile}
                      set_addon_modal_order={set_addon_modal_order}
                      />;
                  }}
                />
            </div>;
          })}
        </Fragment>
        {!!addon_modal_order && <Bandwidth_low_popup
          order={addon_modal_order}
          no_icon={true}
          title='Add more bandwidth to keep your access!'
          per_gb={get_price_per_gb(addon_modal_order)}
          popup_text={'Don’t worry, you can add more '+
            'bandwidth to your'+
            ' plan with the same price per GB ({{price_text}}).'}
          type={'ADD'} on_checkout={extra_checkout}
          on_close={()=>set_addon_modal_order(null)}
          on_success={()=>{
            const email = user?.emails?.[0]?.value;
            history.push(`/dashboard/page/plans`
              +`?notification=extra_limit_success`
              +`&email=${encodeURIComponent(email)}`
            );
            set_addon_modal_order(null);
            dispatch({type: 'refresh_orders'});
          }}/>}
        {is_mobile && (!free_plan_maxed ?
          <div className={cn(styles.plan_actions,
            active && styles.visible)}>
            <div className={styles.container}>
              {visible_actions.config_list && <Button
                caption={'Show configured list'}
                on_click={show_config_list} color={'transparent'}
                size={'sm'} round={false}
              />}
              {visible_actions.generate && <Button caption={'Generate proxy'}
                on_click={generate_proxies} color={'black'}
                size={'sm'} round={false}
              />}
            </div>
          </div> :
          <div className={cn(styles.free_plan_maxed,
            active && styles.visible)}>
            <div className={styles.container}>
              <div className={styles.content_wrapper}>
                <p className={cn(theme.med, theme.color_n700)}>
                  Seems like you're all done with this one!
                </p>
                <p className={cn(theme.p14, theme.color_n500)}>Check out our
                  flexible plans to find the best plan for your budget and
                  needs
                </p>
                <Button caption='Choose a plan' round={false} fit={false} w100
                  size='sm' cls={styles.choose_plan_btn} to={'/pricing'}
                  color="black"/>
              </div>
            </div>
          </div>)}
      </Fragment>;
    }
    return free_zone_fake ? <>
      <Configured_proxy_list
        need_login={props.need_login}
        active={!!(params.configure_proxy && params.type)}
        orders={info.orders}
        free_fake_zone={free_zone_fake}
        zone_groups={info.zone_groups}
        get_product_name={type=>
          list_of_products.find(item=>item.value==type)?.title}
        ui_config={{
          render_new_conf_button: (on_click: ()=>void)=>{
            return <div className={styles.add_new_config}>
              <Button color='transparent' on_click={on_click}
                size={'sm'} round={false}
                caption={<>
                  <Icon_plus />
                  Create another configuration
                </>}/>
              </div>;
          },
        }}
      />
      <div className={styles.plans_content}>
        <Plan_table type={free_zone_fake.type}
          is_free_zone_creating={info.is_free_zone_creating}
          items={[free_zone_fake]}
          countries={props.countries} orders_count={1}
          title={ORDER_TYPE_NAMES[free_zone_fake.type]}
          need_login={props.need_login}
          wrapper_cn={type_to_table_cn[free_zone_fake.type]}
          show_order_token/>
      </div>
    </> : <Empty_plans/>;
};

interface i_plan_actions_props {
    item: t_order;
    is_hidden?: boolean;
    set_addon_modal_order?: (o: t_order)=>void;
}
const Plan_actions = (props: i_plan_actions_props)=>{
    const {item, is_hidden,
        set_addon_modal_order} = props;
    const {theme, show_modal} = useContext(Settings_context);
    const hidden = item.free_zone || is_hidden;
    const show_add_bandwidth_menu_item = item && item?.type == 'smart_resi';
    const per_gb = get_price_per_gb(item);
    const menu_items = useMemo(()=>{
        const res = [];
        if (hidden)
            return [];
        res.push({
            id: 'support_request',
            text: 'Request support',
            icon: Icon_support,
            btn_cls: styles.action_menu_support_req,
            on_click: ()=>{
                show_modal('support_form',
                  p=><Support_form {...p}
                    support_form_data={{
                      token: item.client_id,
                      product: item.type
                    }}
                  />,
                  {lighter_close_btn: true, low_dim: true,
                      paddingless: true, width: 640,
                      cls: styles.support_req_modal,
                      content_cls: styles.support_modal_content});
            },
        });
        if (!is_unlimited_proxy_type(item?.type) &&
            (show_add_bandwidth_menu_item && !!per_gb)
        )
        {
            res.push({
              id: 'add_additional bandwidth',
              text: 'Add more bandwidth',
              icon: Icon_add_to,
              on_click: ()=>set_addon_modal_order(item),
            });
        }
        return res;
    }, [hidden, item]);
    if (!menu_items.length)
        return null;
    return <Action_menu
      menu_cls={styles.plan_menu}
      item_cls={cn(theme.p2, styles.plan_menu_item)}
      position={'left'} items={menu_items}
    />;
};
